import React, { useEffect, useState } from 'react';
import InvoicesService from '../Services/InvoicesService';
import LocalService from '../Services/LocalService';
import { useToasts } from 'react-toast-notifications';
import AuthService from '../Services/AuthService';
import { Row, Col, Button, Input, Card, CardBody, FormGroup, Label, Table} from 'reactstrap';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { withTranslation, t } from 'react-multi-lang';
//import { , Tr, Td, Thead, Tbody, Th } from 'react-super-responsive-table';
import {
    faRefresh
} from "@fortawesome/free-solid-svg-icons";
import VolumesService from '../Services/VolumesService';
import ReactHTMLTableToExcel from 'react-html-table-to-excel';
import { DionysosService } from '../Services/DionysosService';


const Stock = ({t}) => {
    const [config, setConfig] = useState({});
    const [volumes, setVolumes] = useState([]);
    const [search, setSearch] = useState('');

    const authService = new AuthService();
    const volumesService = config.whCode === '219' ? new DionysosService() : new VolumesService();
    const { addToast } = useToasts();

    useEffect(() => {
        setConfig(authService.getConfig());
        getStock();
    }, []);

    const getStock = () => {
        volumesService.getStock().then(r => setVolumes(r.data)).catch(e => addToast(t('stock.errorGettingStock'), {type: 'error'}));
    };

    return  <Card style={{padding: '20px'}}>
            <CardBody>
                <h3>{t('sideBar.stock')}</h3>
                <Row>
                    <Col md="6">
                        <FormGroup>
                            <Input type="search" onChange={e => setSearch(e.target.value)} placeholder="Search"/>
                        </FormGroup>
                    </Col>
                    <Col md="1" className="d-grid">
                        <Button color="primary" size="sm" onClick={getStock}><FontAwesomeIcon icon={faRefresh} /></Button>
                    </Col>
                    <Col md="5" className="d-grid">
                        <ReactHTMLTableToExcel
                            id="unassessedButton"
                            className="btn btn-sm btn-success btn-block"
                            table="stockTable"
                            filename="stock"
                            sheet="volumes"
                            buttonText="Excel"/>
                    </Col>
                </Row>
                
                <Table responsive id="stockTable">
                    <thead>
                        <tr>
                            <th width="10%">{t('volumes.sn')}</th>
                            <th width="10%">{t('volumes.quarryLevel')}</th>
                            <th width="10%">{t('volumes.date')}</th>
                            <th width="10%">{t('volumes.dimensions')} - {t('volumes.dimensionBreakdown')}</th>
                            <th width="40%">{t('volumes.item')}</th>
                            <th width="5%">{t('volumes.wh')}</th>
                            <th width="5%">{t('volumes.assessment')}</th>
                            <th width="10%">{t('volumes.weight')}</th>
                        </tr>
                    </thead>
                    <tbody>
                    {
                        volumes.filter((v) => !v.underReAssessment)
                        .filter(v => v.erpNumber.includes(search) || v.lot.includes(search) 
                        || v.self.includes(search)
                        || volumesService.getVolumeItem(v).includes(search)
                        || volumesService.decideAssessment(v).includes(search) || (v.date.split('T')[0].split('-').reverse()[0] + ' - ' + v.dayNumber).includes(search) )
                        .sort((v1, v2) => v1.date > v2.date ? 1 : -1).map(v => {
                            return <tr key={v.volumeId} style={{borderBottom: '1px solid #aaa'}}>
                                <td >{v.date.split('T')[0].split('-').reverse()[0]} - {v.dayNumber}</td>
                                <td >{v.self}</td>
                                <td >{v.date.split('T')[0].split('-').reverse().join('-')}</td>
                                <td >{ v.measurement && v.measurement?.length + '/' + v.measurement?.width + '/' + v.measurement?.depth}</td>
                                <td >
                                    {volumesService.getVolumeItem(v)} - {volumesService.getVolumeDescr(v)} {" - "}
                                    {t('volumes.volumeNumber')}: <span className="text-primary" style={{fontSize: '21px', fontWeight: 'bold'}}>{v.erpNumber}</span> {" - "}
                                    {t('volumes.lotNumber')}: {v.lot}
                                </td>
                                <td >
                                    {v.whCode}
                                </td>
                                <td >
                                    {volumesService.decideAssessment(v)}
                                </td>
                                <td >
                                    <span style={{fontSize: '20px'}} className="text-primary">{v.weight.toLocaleString()}kg</span>
                                </td>
                            </tr>
                        })
                    }
                    </tbody>
                </Table>
        </CardBody>
    </Card>
};

export default withTranslation(Stock);